<ion-header [translucent]="false" class="ion-no-border custom-header" mode="md">
  <ion-toolbar>
    <ion-title class="modal-title">{{'edit_glass' | translate}}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="configuration-container">

    <!-- Configuration mode -->
    <div class="mode-card">
      <div class="mode-label">
        {{ 'configuration_mode' | translate }}
      </div>

      <ion-segment [value]="mode" (ionChange)="onModeChange($event)" mode="md">

        <ion-segment-button value="by-glass">
          <ion-label class="text-wrap">{{ 'by_glass' | translate }}</ion-label>
        </ion-segment-button>
        <ion-segment-button value="by-brand">
          <ion-label class="text-wrap">{{ 'by_brand' | translate }}</ion-label>
        </ion-segment-button>
        <ion-segment-button value="manual">
          <ion-label class="text-wrap">{{ 'manually' | translate }}</ion-label>
        </ion-segment-button>
      </ion-segment>
    </div>
    <!-- open filter modal -->
     <div>
    <ion-button *ngIf="mode === 'by-glass'" class="filter-btn" fill="clear" (click)="openFilterModal()">
      <ion-icon name="search-outline" slot="start"></ion-icon>
      {{ 'filter' | translate }}
      <span *ngIf="isFilterActive" class="filter-active-dot"></span>
    </ion-button>
    </div>
    <!-- BY BRAND -->
    <ng-container *ngIf="mode === 'by-brand'">
      <div class="select-group">
        <label class="select-label">{{ 'brand' | translate }}</label>
        <ion-select [(ngModel)]="selectedManufacturerId" (ionChange)="onManufacturerChange()" interface="popover" class="styled-select"
          cssClass="select-popover">
          <ion-select-option *ngFor="let m of manufacturers" [value]="m.id">
            {{ m.name }}
          </ion-select-option>
        </ion-select>
      </div>

      <div class="select-group">
        <label class="select-label">{{ 'region' | translate }}</label>
        <ion-select [(ngModel)]="selectedCountryId" interface="popover" class="styled-select" cssClass="select-popover">
          <ion-select-option *ngFor="let c of sortedAvailableCountries" [value]="c.id">
            {{ c.name | translate }}
          </ion-select-option>
        </ion-select>
      </div>
    </ng-container>

    <!-- BY GLASS -->
    <ng-container *ngIf="mode === 'by-glass'">

      <app-edit-glass-list [glasses]="getFilteredGlasses()" [selectedGlass]="selectedGlass"
        (glassSelected)="selectGlass($event)" (glassInfoClicked)="showGlassInfo($event)">
      </app-edit-glass-list>
    </ng-container>

    <!-- MANUAL -->
    <ng-container *ngIf="mode === 'manual'">
      <div class="form-container">
        <div class="select-group">
          <label class="select-label">{{'HEADER_NAME' | translate}}</label>
          <ion-input class="bordered-input" type="text" [(ngModel)]="eManGlassName" name="eManGlassName"
            (ionInput)="validateForm()" (ionBlur)="validateForm()">
          </ion-input>
        </div>

        <div class="select-group">
          <label class="select-label">{{'UG' | translate}} (W/m²K)</label>
          <ion-input class="bordered-input" type="number" [(ngModel)]="eManGlassUg" name="eManGlassUg" step="0.01"
            min="0">
          </ion-input>
        </div>

        <div class="select-group">
          <label class="select-label">{{ 'G-VALUE' | translate }} (%)</label>
          <ion-select [(ngModel)]="eManGlassGValue" interface="popover" class="styled-select" cssClass="select-popover">
            <ion-select-option *ngFor="let val of gValueOptions" [value]="val">
              {{ val }}%
            </ion-select-option>
          </ion-select>
        </div>

        <div class="select-group">
          <label class="select-label">{{ 'HEADER_GLAZING' | translate }}</label>
          <ion-select [(ngModel)]="eManGlassGlazing" (ionChange)="onGlazingChange()" interface="popover"
            class="styled-select" cssClass="select-popover">
            <ion-select-option [value]="1">1</ion-select-option>
            <ion-select-option [value]="2">2</ion-select-option>
            <ion-select-option [value]="3">3</ion-select-option>
            <ion-select-option [value]="4">4</ion-select-option>
          </ion-select>
        </div>
        <!-- Single Glazing -->
        <ng-container *ngIf="eManGlassGlazing === 1">
          <div class="select-group">
            <label class="select-label">{{ 'HEADER_GLASS_THICKNESS_MM' | translate }}</label>
            <ion-select [(ngModel)]="eManGlassExternal" interface="popover" class="styled-select"
              cssClass="select-popover">
              <ion-select-option *ngFor="let thickness of glassThicknessOptions" [value]="thickness">
                {{ thickness }}
              </ion-select-option>
            </ion-select>
          </div>
        </ng-container>
        <!-- > Double Glazing -->
        <ng-container *ngIf="eManGlassGlazing >= 2">
          <div class="select-group">
            <label class="select-label">{{ 'HEADER_GLASS_EXTERNAL' | translate }}</label>
            <ion-select [(ngModel)]="eManGlassExternal" interface="popover" class="styled-select"
              cssClass="select-popover">
              <ion-select-option *ngFor="let thickness of glassThicknessOptions" [value]="thickness">
                {{ thickness }}
              </ion-select-option>
            </ion-select>
          </div>
          <div class="select-group" *ngIf="eManGlassGlazing == 3">
            <label class="select-label">{{ 'HEADER_GLASS_MIDDLE' | translate }}</label>
            <ion-select [(ngModel)]="eManGlassMiddle" interface="popover" class="styled-select"
              cssClass="select-popover">
              <ion-select-option *ngFor="let thickness of glassThicknessOptions" [value]="thickness">
                {{ thickness }}
              </ion-select-option>
            </ion-select>
          </div>
          <div class="select-group">
            <label class="select-label">{{ 'HEADER_GLASS_INTERNAL' | translate }}</label>
            <ion-select [(ngModel)]="eManGlassInternal" interface="popover" class="styled-select"
              cssClass="select-popover">
              <ion-select-option *ngFor="let thickness of glassThicknessOptions" [value]="thickness">
                {{ thickness }}
              </ion-select-option>
            </ion-select>
          </div>
          <div class="select-group">
            <label class="select-label">{{ 'HEADER_CAVITY1' | translate }}</label>
            <ion-select [(ngModel)]="eManCavity1" interface="popover" class="styled-select" cssClass="select-popover">
              <ion-select-option *ngFor="let cavity of cavityOptions" [value]="cavity">
                {{ cavity }}
              </ion-select-option>
            </ion-select>
          </div>
        </ng-container>
        <!-- > triple Glazing -->
        <ng-container *ngIf="eManGlassGlazing >= 3">
          <div class="select-group">
            <label class="select-label">{{ 'HEADER_CAVITY2' | translate }}</label>
            <ion-select [(ngModel)]="eManCavity2" interface="popover" class="styled-select" cssClass="select-popover">
              <ion-select-option *ngFor="let cavity of cavityOptions" [value]="cavity">
                {{ cavity }}
              </ion-select-option>
            </ion-select>
          </div>
        </ng-container>

        <!-- glazing = 4) -->
        <ng-container *ngIf="eManGlassGlazing === 4">
          <div class="select-group">
            <label class="select-label">{{ 'HEADER_CAVITY3' | translate }}</label>
            <ion-select [(ngModel)]="eManCavity3" interface="popover" class="styled-select" cssClass="select-popover">
              <ion-select-option *ngFor="let cavity of cavityOptions" [value]="cavity">
                {{ cavity }}
              </ion-select-option>
            </ion-select>
          </div>
        </ng-container>
      </div>
      <p style="text-align: left;">{{'NOTE_GLASS_MANUAL' | translate}}</p>
    </ng-container>

  </div>
</ion-content>

<ion-footer [translucent]="false" class="ion-no-border">
  <ion-item lines="none" class="checkbox-item">
    <ion-checkbox slot="start" [(ngModel)]="glassCorrectionFactor">
    </ion-checkbox>
    <ion-label>{{'HEADER_CORRECTION_FACTOR' | translate}}</ion-label>
  </ion-item>
  <div class="button-container">
    <ion-button fill="outline" class="cancel-btn" (click)="cancel()" expand="block">
      {{'cancel' | translate}}
    </ion-button>
    <ion-button class="next-btn" (click)="next()" expand="block" [disabled]="isNextButtonDisabled()">
      {{ (mode === 'by-brand' ? 'next' : 'validate') | translate }}
    </ion-button>
  </div>
</ion-footer>